<template>
    <div class="__cursepreview mb-2">
        <div class="d-flex p-3 b-white rounded shadow-sm align-items-center">
            <div class="_nocover mr-2 rounded">
                <img :src="curseParent.cover == null ? 'https://picsum.photos/400/400/?image=20' : curseParent.cover "
                     alt=""  width="35" height="35" class="rounded img-fluid">
            </div>
            <span class="font-blue font-weight-bold text-left">{{curseParent.title}}</span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'CurseNavBar',
    props:{
        curseParent: Object
    },
    data() {
        return {

        }
    },
    created() {

},
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/curses/components/CurseNavBar.vue